const API_URL = process.env.REACT_APP_API_URL || (window.location.origin + '/api');
const getHeaders = () => {
  const token = localStorage.getItem('token');
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) };
};
const handle = async (res) => { const data = await res.json(); if (!res.ok) throw new Error(data.error || 'Error'); return data; };
export const incidentApi = {
  getAll: (params = {}) => { const q = new URLSearchParams(params).toString(); return fetch(`${API_URL}/incidents${q ? '?' + q : ''}`, { headers: getHeaders() }).then(handle); },
  getOne: (id) => fetch(`${API_URL}/incidents/${id}`, { headers: getHeaders() }).then(handle),
  getStats: () => fetch(`${API_URL}/incidents/stats`, { headers: getHeaders() }).then(handle),
  getByAsset: (assetId) => fetch(`${API_URL}/incidents/by-asset/${assetId}`, { headers: getHeaders() }).then(handle),
  create: (data) => fetch(`${API_URL}/incidents`, { method: 'POST', headers: getHeaders(), body: JSON.stringify(data) }).then(handle),
  update: (id, data) => fetch(`${API_URL}/incidents/${id}`, { method: 'PATCH', headers: getHeaders(), body: JSON.stringify(data) }).then(handle),
  addComment: (id, data) => fetch(`${API_URL}/incidents/${id}/comments`, { method: 'POST', headers: getHeaders(), body: JSON.stringify(data) }).then(handle),
  delete: (id) => fetch(`${API_URL}/incidents/${id}`, { method: 'DELETE', headers: getHeaders() }).then(handle),
  searchAssets: (q) => fetch(`${API_URL}/assets/search?q=${encodeURIComponent(q)}`, { headers: getHeaders() }).then(handle),
  subscribeEvents: (onEvent) => {
    const token = localStorage.getItem('token');
    const es = new EventSource(`${API_URL}/incidents/events?token=${token}`);
    es.onmessage = (e) => { try { const d = JSON.parse(e.data); if (d.type !== 'heartbeat') onEvent(d); } catch {} };
    return es;
  }
};
